export default {
    message: {
      "strid1": "Halaman Utama",
      "strid2": "Tutorial",
      "strid3": "Event",
      "strid4": "Bergabunglah dengan Kami",
      "strid5": "Discord",
      "strid6": "Akademi Creator",
      "strid7": "Karya yang Dipilih",
      "strid8": "Kembali",
      "strid9": "Berpartisipasi Sekarang",
      "strid10": "Event Lainnya",
      "strid11": "Informasi Pribadi",
      "strid12": "Server Game",
      "strid13": "Silakan masukkan Server Anda",
      "strid14": "ID Game",
      "strid15": "Silakan masukkan ID Game Anda",
      "strid16": "Informasi Kontak",
      "strid17": "Pilih Platform",
      "strid18": "Silakan masukkan informasi kontak Anda",
      "strid19": "Detail Pekerjaan",
      "strid20": "Platform Publikasi",
      "strid21": "Silakan masukkan Link yang benar",
      "strid22": "Tap untuk menambahkan Link baru",
      "strid23": "Bahasa yang Digunakan",
      "strid24": "Pilih bahasa yang digunakan",
      "strid25": "Bahasa Inggris",
      "strid26": "Bahasa Arab",
      "strid27": "Bahasa Spanyol",
      "strid28": "Portugis",
      "strid29": "Khmer",
      "strid30": "Burma",
      "strid31": "Bahasa Malaysia",
      "strid32": "Lainnya",
      "strid33": "Saya mengonfirmasi kepemilikan karya dan memahami kebijakan ini",
      "strid34": "Kumpulkan",
      "strid35": "Dikumpulkan!",
      "strid36": "Hak Istimewa",
      "strid37": "Bergabunglah dengan kami sekarang untuk memperoleh",
      "strid38": "Dukungan dari media sosial resmi MLBB",
      "strid39": "Komunitas interaktif Creator",
      "strid40": "Hadiah Diamond Mingguan",
      "strid41": "Lebih banyak hak istimewa terbuka",
      "strid42": "Merchandise Game",
      "strid43": "Event Offline",
      "strid44": "Skin Berlimpah",
      "strid45": "Kolaborasi Brand",
      "strid46": "Promosi iklan",
      "strid47": "Bergabunglah dengan Kami",
      "strid48": "Persyaratan",
      "strid49": "FOLLOW KAMI",
      "strid50": "Tap untuk mengecek akun resmi MLBB",
      "strid51": "Kebijakan Konten",
      "strid52": "Silakan melengkapi informasi",
      "strid53": "Pengiriman gagal",
      "strid54": "Please Enter Your Channel Link",  // 请输入正确的频道链接
      "strid55": "Pilih wilayah Anda",
      "strid56": "Wilayah Anda",



    }
  }
